import { useEffect, useState } from "react";
import WelcomePopup from "components/Popup/WelcomePopup";
import Home from "pages/home/Home";
import ToppersCopies from "pages/free-resources/toppers-copies/ToppersCopies";
import { isLoggedIn } from "config/utils";
import { Link, useNavigate, useLocation } from "react-router-dom";
import OurToppers from "dashboard/our-toppers/OurToppers";
import Header from "components/header/User/Header";
import NewOurToppers from "dashboard/our-toppers/NewOurToppers";

const TopperNavigator = () => {
  const [loginFlag, setLoginFlag] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {

    if (!isLoggedIn()) {
      setLoginFlag(true);
      localStorage.setItem("topperpage", "yes");
      navigate("/login");
    } else {
      setLoginFlag(false);
    }
  }, []);

  return (
    <div>
      {!loginFlag && 
      <div>
      <Header/>
        <NewOurToppers />
        </div>
     }
    </div>
  );
};

export default TopperNavigator;
